import * as angular from 'angular';
import template from './aiServerConfig.tpl.html';

export default angular.module('aps.controller.aiServerConfig', [])
  .directive('apsAiServerConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/aiServerConfig.directive.ts